import { integrationTypeSchema } from './integration-type.schema';
import { z } from 'zod/v4';

export const partnerSettingsSchema = z.object({
  accountPartnerId: z.number(),
  partnerId: z.string().nullable(),
  externalIdType: z.number().nullable(),
  integrationType: integrationTypeSchema,
  enabled: z.boolean(),
  enableAssetReplication: z.boolean(),
  enableAmsDiagnostics: z.boolean(),
});

export type PartnerSettings = z.infer<typeof partnerSettingsSchema>;
